// extracted by mini-css-extract-plugin
module.exports = {"Empty":"ProductsList_Empty__1VDxw","Products":"ProductsList_Products__1nPpB","Product":"ProductsList_Product__3_97R"};